<script setup>

import { computed, ref, watch } from 'vue'

import InputRadio from '@/components/form/InputRadio.vue'
import PaymentMethodAppleSvg from '@/components/icons/PaymentMethodAppleSvg.vue'
import PaymentMethodCardSvg from '@/components/icons/PaymentMethodCardSvg.vue'
import PaymentMethodGoogleSvg from '@/components/icons/PaymentMethodGoogleSvg.vue'
import { useFormDataStore } from '@/stores/FormDataStore'
import { usePaymentGatewaysStore } from '@/stores/PaymentGatewaysStore'
import { useSubscriptionsStore } from '@/stores/SubscriptionsStore'
import { useHelpers } from '@/useHelpers'

const {formatMoney} = useHelpers()
const paymentGatewayStore = usePaymentGatewaysStore()
const subscriptionStore = useSubscriptionsStore()
const formDatastore = useFormDataStore()

const props = defineProps({
  paymentGateway: {
    type: String,
    default: ''
  }
})

const currentPaymentGateway = ref(props.paymentGateway)
const emits = defineEmits(['update:paymentGateway'])
const isApplePaySupported = computed(() => !!window.ApplePaySession)

watch(currentPaymentGateway, (newValue) => {
  emits('update:paymentGateway', newValue)
})

watch(() => props.paymentGateway, (newValue) => {
  currentPaymentGateway.value = newValue
})
</script>

<template>
  <div
    v-for="paymentGateway in paymentGatewayStore.allWithoutFree"
    :key="paymentGateway.code"
    class="input-group radio-group"
  >
    <InputRadio
      v-model="currentPaymentGateway"
      :label="paymentGateway.name"
      :value="paymentGateway.code"
    >
      <template v-if="paymentGatewayStore.isGoPayGateway(paymentGateway.code)">
        <div class="image_payment-methods">
          <PaymentMethodCardSvg />
          <PaymentMethodGoogleSvg />
          <PaymentMethodAppleSvg v-if="isApplePaySupported" />
        </div>
      </template>
      <template v-if="paymentGateway.is_recurrent">
        <p v-if="formDatastore.isVariantTrial" class="input-group__description"
           v-html="$t('After the trial period of 7 days (168 hours) expires, you will be charged the current subscription price (Digi Premium annual). You can cancel the recurring payment at any time in your account or at email.', {
                   email: $t('email-subscription')
                 })"
        />
        <p v-else class="input-group__description"
           v-html="$t('The next recurring payment in the amount of amount will take place after the subscription expires. You can cancel the recurring payment at any time in your account or at email.', {
                   amount: formatMoney(subscriptionStore.finalPrice),
                   email: $t('email-subscription')
                 })"
        />
      </template>
    </InputRadio>
  </div>
</template>

<style scoped lang="scss">
.image_payment-methods {
  display: flex;
  gap: 8px;
  padding-top: 12px;
}
</style>